module.exports = __webpack_public_path__ + "img/keitaro-landing-step-1.en.b546c664.jpg";